import { getStartOfStamp } from "./getTimeGroupData"

export const generateTimestamps = (s: string | number | Date, end: string | number | Date, time_group: string): (string | number)[] => {
    const timestamps = []
    const [multiplier = 1, increment] = time_group?.split(' ') || []
    const new_start = getStartOfStamp(s, increment, {tz: 'UTC'}) 
    let inc = 1000 // seconds
    if (['minute', 'minutes'].includes(increment)) inc = 60 * 1000
    if (['hour', 'hours'].includes(increment)) inc = 60 * 60 * 1000
    if (['day', 'days'].includes(increment)) inc = 60 * 60 * 24 * 1000
    if (['week', 'weeks'].includes(increment)) inc = 60 * 60 * 24 * 7 * 1000
    if (['month', 'months'].includes(increment)) inc = 60 * 60 * 24 * 30 * 1000
    if (['year', 'years'].includes(increment)) inc = 60 * 60 * 24 * 365 * 1000
    inc = inc * Number(multiplier)
    let start = new Date(new_start).getTime()
    while (start < new Date(end).getTime() + inc) {
      timestamps.push(start)
      start = start + inc
    }
    return timestamps
  }